import { Box, BoxProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

const Divider = forwardRef<HTMLDivElement, BoxProps>(function Divider(props, ref) {
    return <Box h="1px" w="100%" bg="colorPalette.200" colorPalette="gray" ref={ref} {...props} />;
});

Divider.displayName = 'Divider';

export { Divider };
